document.addEventListener('DOMContentLoaded', () => {
// slick default setting
let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

// start slider default
  let allSwipper =[];

document.querySelectorAll('.swiper-js').forEach((element,i) => {

  let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

  element.setAttribute(`data-swiper-${i}`,"");

  let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

      allSwipper[i] = swiper;

      //custom count
      if(swiper.passedParams.customcount){
          let countcontainerall = document.querySelectorAll(`${swiper.passedParams.customcount}`);
          countcontainerall.forEach((element) => {element.innerHTML = `0${swiper.realIndex + 1}`});
          swiper.on('slideChange', () => {
              countcontainerall.forEach((element) =>{
                  element.innerHTML = `0${swiper.realIndex + 1}`;
              });
          });
      }

});

  //custom swiper controller
  allSwipper.forEach((swiper) => {
      const customControl = swiper.passedParams.customcontrol;
      if (customControl) {
          const targetIds = customControl.substr(1).split(" ");
          const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
          if (targetSwipers.length > 0) {
              swiper.controller.control = targetSwipers;
          }
      }
  });

});